/* oxlint-disable @fullscript/gql-file-usage */
// REASON: pre-existing operation file, to be migrated to a .gql file in a follow up MR
import { gql } from "@apollo/client";

const VerifySignInMFA_Shared_Mutation = gql`
  mutation VerifySignInMFA_Shared_Mutation($input: AuthUserTwoFactorAuthenticationVerifyInput!) {
    auth {
      userVerifyTwoFactorAuthentication(input: $input) {
        locked
        redirectPath
        returnToSignin
        newBackupCode
        roleType
        errors {
          message
        }
      }
    }
  }
`;

export { VerifySignInMFA_Shared_Mutation };
